import Rosa from "../assets/Rosa.png";
import Nai from "../assets/Nai.png";
import Rach from "../assets/Rach.png";

const people = [
  {
    name: "Giselle Chacon",
    role: "CEO / Software Engineer",
    imageUrl:
      "https://img.seadn.io/files/2f76c1d4964b0cb327f0081c48ce14e2.png?fit=max&w=600",
    twitterUrl: "https://twitter.com/Gi_Chacon",
    linkedinUrl: "https://www.linkedin.com/in/gisellechacon/",
  },
  {
    name: "Rosada",
    role: "Business & Strategy",
    imageUrl: Rosa,
      twitterUrl: "https://twitter.com/Cryptotonga1",
    linkedinUrl: "https://www.linkedin.com/in/rosa-jerez-017a34233/",
  },
  {
    name: "Genializa",
    role: "Copy Writer & Content Creator",
    imageUrl:
    "https://img.seadn.io/files/ef53cf0b5d9968292e17117a9e0f534c.png?fit=max&w=600",
      twitterUrl: "https://twitter.com/maria_eliza06",
    linkedinUrl: "https://www.linkedin.com/in/maria-elizabeth-cabe%C3%A7udo-cruz-05134214/",
  },
  {
    name: "Nairobi",
    role: "Finance & Community Building",
    imageUrl: Nai,
      twitterUrl: "https://twitter.com/ms_nairobi",
    linkedinUrl: "https://www.linkedin.com/in/montillandrea/",
  },
  {
    name: "Rachel",
    role: "Podcast Editor & Marketing",
    imageUrl: Rach,
      twitterUrl: "https://twitter.com/RachelAlmonte_",
    linkedinUrl: "https://www.linkedin.com/in/rachel-almonte-9b1357245/",
  },
  {
    name: "Ambs",
    role: "Project Manager & Community Building",
    imageUrl:
    "https://img.seadn.io/files/e2234c6c0c7af143798a4e91c91662e4.png?fit=max&w=600",
      twitterUrl: "https://twitter.com/ambaaaaaaar",
    linkedinUrl: "https://www.linkedin.com/in/ambar-marcus-12363b60/",
  },
  {
    name: "Joi",
    role: "Creative Designer",
    imageUrl:
    "https://lh3.googleusercontent.com/JAkjNpoO4PqfMpNmrjX9BQOPkCUQqMh8XIIW-_B_P1ML778ecgl1eKzuLGMNCnhi-UitEW9jyQQLXbi0EUi86Yza3Es4ty_ZAKWo6w=w600",
      twitterUrl: "https://twitter.com/Joitac",
    linkedinUrl: "https://www.linkedin.com/in/joeleen-contreras-scott-7b425424b/",
  },
];

export default function Team() {
  return (
    <div className="py-24 sm:py-32">
      <div className="mx-auto grid max-w-7xl gap-y-20 gap-x-8 px-6 lg:px-8 xl:grid-cols-3">
        <div className="max-w-2xl text-left">
          <h2 className="text-3xl font-bold tracking-tight text-gray-100 sm:text-4xl">
            Conoce a las Cryptonikas
          </h2>
          <p className="mt-6 text-lg leading-8 text-gray-200">
            Fundadoras de Cryptonikas DAO.
          </p>
        </div>
        <ul
          role="list"
          className="grid gap-x-8 gap-y-12 sm:grid-cols-2 sm:gap-y-16 xl:col-span-2 text-left text-gray-200"
        >
          {people.map((person) => (
            <li key={person.name}>
              <div className="flex items-center gap-x-6">
                <img
                  className="h-16 w-16 rounded-full"
                  src={person.imageUrl}
                  alt=""
                />
                <div>
                  <h3 className="text-base font-semibold leading-7 tracking-tight text-gray-200">
                    {person.name}
                  </h3>
                  <p className="text-sm font-semibold leading-6 text-gray-400">
                    {person.role}
                  </p>

                  <ul role="list" class="flex justify-left space-x-5 text-left">
                    <li>
                      <a
                        href={person.twitterUrl}
                        target="_blank"
                        class="text-gray-200 hover:text-gray-400"
                      >
                        <span class="sr-only">Twitter</span>
                        <svg
                          class="w-4 h-4"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                          aria-hidden="true"
                        >
                          <path d="M6.29 18.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0020 3.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.073 4.073 0 01.8 7.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 010 16.407a11.616 11.616 0 006.29 1.84" />
                        </svg>
                      </a>
                    </li>
                    <li>
                      <a
                        href={person.linkedinUrl}
                        target="_blank"
                        class="text-gray-200 hover:text-gray-400"
                      >
                        <span class="sr-only">LinkedIn</span>
                        <svg
                          class="w-4 h-4"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                          aria-hidden="true"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M16.338 16.338H13.67V12.16c0-.995-.017-2.277-1.387-2.277-1.39 0-1.601 1.086-1.601 2.207v4.248H8.014v-8.59h2.559v1.174h.037c.356-.675 1.227-1.387 2.526-1.387 2.703 0 3.203 1.778 3.203 4.092v4.711zM5.005 6.575a1.548 1.548 0 11-.003-3.096 1.548 1.548 0 01.003 3.096zm-1.337 9.763H6.34v-8.59H3.667v8.59zM17.668 1H2.328C1.595 1 1 1.581 1 2.298v15.403C1 18.418 1.595 19 2.328 19h15.34c.734 0 1.332-.582 1.332-1.299V2.298C19 1.581 18.402 1 17.668 1z"
                            clip-rule="evenodd"
                          />
                        </svg>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
